import { render, staticRenderFns } from "./Area_Seletor.vue?vue&type=template&id=78511c0c"
import script from "./Area_Seletor.vue?vue&type=script&lang=js"
export * from "./Area_Seletor.vue?vue&type=script&lang=js"
import style0 from "./Area_Seletor.vue?vue&type=style&index=0&id=78511c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports